module.exports = __webpack_public_path__ + "static/media/indigo.9869a4f2.webp";